export default "__VITE_ASSET__CkPZR1bA__"